var map = {
	"./af.json": 2914,
	"./ar.json": 5310,
	"./bn.json": 7581,
	"./cs.json": 3571,
	"./da.json": 9914,
	"./de.json": 5894,
	"./el.json": 4524,
	"./en.json": 4174,
	"./es.json": 6725,
	"./fa.json": 3248,
	"./fr.json": 4605,
	"./he.json": 6282,
	"./hi.json": 3134,
	"./hu.json": 6938,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./jv.json": 9373,
	"./lt.json": 5449,
	"./nl.json": 4943,
	"./pl.json": 1029,
	"./pt-br.json": 5960,
	"./pt.json": 7741,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./sk.json": 347,
	"./sv.json": 8252,
	"./th.json": 7549,
	"./tr.json": 9755,
	"./uk.json": 2749,
	"./zh.json": 9527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1304;